/* unplugin-vue-components disabled */import { render } from "./imageText.vue?vue&type=template&id=14844e91&scoped=true"
import script from "./imageText.vue?vue&type=script&lang=js"
export * from "./imageText.vue?vue&type=script&lang=js"

import "./imageText.vue?vue&type=style&index=0&id=14844e91&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14844e91"]])

export default __exports__